<template>
  <v-dialog
    v-model="dialog"
    width="800px">
    <div class="dialog-container">
      <div class="dialog-header">
        <h2>New Claim Ticket</h2>
        <div class="btn-container">
          <v-button
            size="small"
            @click="dialog = false">Cancel</v-button>
          <v-button
            size="small"
            type="primary"
            @click="handlerCreate">Create</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div class="dialog-content flex">
          <div class="left">
            <div class="form-item">
              <span>Assignee</span>
              <el-form-item prop="assignee_id">
                <v-select
                  v-model="formData.assignee_id"
                  :disabled="!!form.assignee_id"
                  :list="globalOptions.assignee" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Customer</span>
              <el-form-item
                prop="customer_id"
              >
                <el-select
                  v-if="!!form.customer_id"
                  v-model="customerName"
                  disabled
                  size="small"
                >
                  <el-option
                    :label="customerName"
                    :value="customerName"></el-option>
                </el-select>
                <v-select
                  v-else
                  v-model="formData.customer_id"
                  :list="customerOptions"
                  nameGroup
                  :disabled="!!form.customer_id"
                  :clearable="true" />
                
              </el-form-item>
            </div>
          </div>
          <div class="right">
            <div class="form-item">
              <span>Accident Date</span>
              <el-form-item prop="accident_date">
                <v-date-picker v-model="formData.accident_date" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Contact Person</span>
              <el-form-item prop="contact_person">
                <v-input
                  v-model="formData.contact_person" />
              </el-form-item>
            </div>

            <div class="form-item">
              <span>Contact Number</span>
              <el-form-item prop="contact_no">
                <v-input
                  v-model="formData.contact_no" />
              </el-form-item>
            </div>
            <div class="form-item mg-b-10">
              <span>Brief Description Of The Acident</span>
              <el-form-item prop="description">
                <v-input
                  v-model="formData.description" />
              </el-form-item>
            </div>
            <span
              v-for="(item, index) in claimFormList"
              :key="index"
              class="font-16 blue pointer block mg-b-10"
              @click="downloadClaimForm(item.url)">{{ item.name }}</span>
            <div class="form-item">
              <span>Documents</span>
              <section v-if="formData.other_file.length > 0">
                <file-container
                  v-for="(item, index) in formData.other_file"
                  :key="index"
                  :fileData="item"
                  :edit="true"
                  :otherData="{
                    index
                  }"
                  titleName= "Documents"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="deleteOtherFile">
                  <!-- document{{ index+1 }} -->
                </file-container>
              </section>
              <v-upload
                @uploadSuccess="handlerUploadSuccess" />
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import FileContainer from '@/views/components/file-container'
import { getClaimForm, createClaimTicket } from '@/api/ticket'
export default {
  name: 'NewClaimTicket',
  components: {
    FileContainer
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    orderId: {
      type: [String, Number],
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    },
    customer:{
      type: Object,
      default: () => ({})
    },
    continute: {
      type: Boolean,  // 創建完是否跳轉 ticket 詳情
      default: true
    }
  },
  data() {
    return {
      dialog:false,
      // claimFormUrl: '',
      claimFormList: [],
      formData: {
        accident_date: '',
        contact_person: '',
        contact_no: '',
        description: '',
        other_file: [],
        assignee_id: '',
        customer_id: ''
      }
    }
  },
  computed:{
    customerName(){
      return this.customer.isrd_nm ? this.customer.isrd_nm : ' '
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = Object.assign(this.formData, val)
        let name = localStorage.getItem('cs_name')
        let arr = this.globalOptions.assignee||[]
        arr.some(item=>{
          if(item.name==name){
            this.formData.assignee_id = item.id
          }
        })
      }
    },
    orderId: {
      immediate: true,
      handler(val) {
        if(val) {
          this.network().getClaimForm()
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerCreate() {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.network().createClaimTicket()
        }
      })
    },
    // 上傳完文件
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      if(!this.formData.other_file) {
        this.formData.other_file = []
      }
      if(index !== '') {
        this.$set(this.formData.other_file, index, data)
      }
      else {
        this.formData.other_file.push(data)
      }
    },
    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    downloadClaimForm(url) {
      window.open(url, '_blank')
      // if(!this.claimFormUrl) {
      //   await this.network().getClaimForm()
      // }
      // window.open(this.claimFormUrl, '_blank')
    },
    network() {
      return {
        getClaimForm: async () => {
          const { data } = await getClaimForm({
            order_id: this.orderId,
            hideLoading: true
          })
          console.log('data---',data)
          this.claimFormList = data.claim_form_download
          // this.claimFormUrl = data.download_url
        },
        createClaimTicket: async () => {
          const { data } = await createClaimTicket({
            ...this.formData,
            order_id: this.orderId
          })
          this.changeDialog()

          if(this.continute) {
            this.$router.push({
              path: '/tickets/detail',
              query: {
                ticket_id: data.id
              }
            })
          }
          else {
            this.$emit('success')
          }
          
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    color: #616266;
    // h2 {
    //   font-size: 24px;
    // }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      h1 {
        font-size: 24px;
      }
    }
    .dialog-content {
      padding-top: 15px;
      & > div {
        flex: 1;
      }
      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }
      .right {
        padding-left: 15px;
      }
    }
  }
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
  .el-input__suffix-inner{
    i{
      height: 32px;
      line-height: 32px;
    }
  }
}
//.el-select-dropdown__item {
//  height: auto;
//  line-height: auto;
//  .send-info {
//    padding-bottom: 5px;
//    span {
//      display: block;
//      line-height: 15px;
//      font-size: 12px;
//    }
//  }
//}
</style>